import * as types from '../constants/profile';
import api from '../api';

const setOrders = arr => dispatch =>
  dispatch({
    type: types.SET_ORDERS,
    payload: arr,
  });

const setLoader = bool => dispatch =>
  dispatch({
    type: types.SET_LOADER,
    payload: bool,
  });

const setFilters = filter => dispatch => {
  dispatch({
    type: types.SET_FILTERS,
    payload: filter,
  });
  dispatch(fetchOrders());
};

const fetchOrders = () => async (dispatch, getState) => {
  try {
    dispatch(setLoader(true));
    const { filters } = getState().profile;
    let { data, status } = await api.get('/profile/order', {
      params: filters,
    });
    if (status === 200) {
      dispatch(setOrders(data.data));
    }
    dispatch(setLoader(false));
  } catch (ex) {
    console.error(ex);
    dispatch(setLoader(false));
  }
};

export { fetchOrders, setFilters };
